<template>
    <a-menu :class="$style.root" theme="dark" mode="horizontal" :default-selected-keys="['IndexVideoView']" @click="onClickMenuItem">
        <a-menu-item key="IndexVideo">
            <span>首页</span>
        </a-menu-item>
        <a-menu-item key="LiveVideoView">
            <span>正在直播</span>
        </a-menu-item>
        <a-menu-item key="RecommendView">
            <span>资源平台</span>
        </a-menu-item>

    </a-menu>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'SideMenu',
        computed: {
            ...mapState(['userInfo']),

        },
        methods: {
            onClickMenuItem({ key }) {
                if (key !== 'IndexVideo') {
                    if (!this.userInfo.role_id) {
                        this.$message.config({
                            top: '100px',
                            duration: 2,
                            maxCount: 1,
                        });
                        this.$message.info('请先登录查看');
                        return;
                    }
                }
                this.$router.push({
                    name: key,
                }).catch(() => {});
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        background: transparent !important;

        :global {
            .ant-menu-item,
            .ant-menu-submenu-title {
                font-size: 14px !important;
                line-height: 54px !important;
                height: 54x !important;

                .anticon {
                    font-size: 20px;
                }
            }

            .ant-menu-submenu {
                .ant-menu-sub {
                    background: transparent !important;
                    box-shadow: none !important;
                }

                .ant-menu-item {
                    font-size: 16px !important;
                    line-height: 50px !important;
                    height: 50px !important;

                    .anticon {
                        font-size: 18px;
                    }
                }
            }

            .ant-menu-item-selected {
                background-color: #327de7 !important;
                color: #fff !important;
            }
        }
    }
</style>
